/** The API returns difficulty in whichever language the row was authored in. */
export function normalizeDifficulty(d?: string | null): string {
  const v = (d ?? "").toString().trim().toLowerCase();
  if (v === "easy" || v === "سهل") return "easy";
  if (v === "medium" || v === "متوسط") return "medium";
  if (v === "hard" || v === "صعب") return "hard";
  return v;
}
